(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("draped-feature-collection", [], factory);
	else if(typeof exports === 'object')
		exports["draped-feature-collection"] = factory();
	else
		root["draped-feature-collection"] = factory();
})(self, function() {
return 